export const SVG_ID = 'svgMaze';
export const LOOK_ID = 'look';
